'use client'

import BurgerButton from '@/components/ui/BurgerButton'
import { TimeDisplay } from '@/components/ui/TimeDisplay'
import { motion } from 'framer-motion'
import Image from 'next/image'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'
import MobileNavLink from './MobileNavLink'
import NavLink from './NavLink'

const variants = {
  hidden: {
    opacity: 0,
    y: -100
  },
  enter: {
    opacity: 1,
    y: 0
  }
}

export const NavBar = () => {
  const pathname = usePathname()
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setIsOpen(false)
  }, [pathname])

  return (
    <>
      <motion.nav
        variants={variants}
        initial="hidden"
        exit="exit"
        animate="enter"
        transition={{ type: 'ease-in-out', duration: 0.4 }}
        className=" max-w-[1432px] w-full mx-auto hidden lg:block z-[100]"
      >
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-row items-center">
            <Link href="/">
              <Image src={'/images/logos/kommers-logo.svg'} width={50} height={50} className="mr-5 h-full w-auto max-w-none object-cover" alt="KOMMERS Logo" />
            </Link>
            <div className="w-2 h-2 mr-2 rounded-full bg-KMRSx24-Orange" />
            <p className="text-KMRSx24-GreyLight">
              Fürth, Deutschland <TimeDisplay />
            </p>
          </div>
          <ul className="flex flex-row items-center gap-x-6">
            <NavLink exact href="/" title="Home" />
            <NavLink href="/leistungen" title="Leistungen" />
            <NavLink href="/projekte" title="Projekte" />
            <NavLink href="/about" title="Über uns" />
            <NavLink href="/news" title="News" />
            <NavLink href="/kontakt" title="Kontakt" />
          </ul>
        </div>
      </motion.nav>

      <nav className="mx-auto p-8 border border-KMRSx24-Orange rounded-3xl bg-KMRS-Darkmode  fixed top-16 z-50 left-8 right-8 lg:hidden ">
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-row items-center">
            <Link href="/">
              <figure>
                <Image src={'/images/logos/kommers-logo.svg'} width={35} height={35} className="mr-5 aspect-square max-w-none object-cover" alt="KOMMERS Logo" />
              </figure>
            </Link>
            <div className="w-2 h-2 mr-2 rounded-full bg-KMRSx24-Orange" />
            <p className="text-KMRSx24-GreyLight font-light text-xs leading-3 line-clamp-6">
              Fürth, DE <TimeDisplay />
            </p>
          </div>
          <BurgerButton isOpen={isOpen} onClick={() => setIsOpen((prev) => !prev)} />
        </div>
        <motion.div
          className="h-0 overflow-hidden"
          animate={isOpen ? 'open' : 'closed'}
          variants={{
            open: { height: 'auto' }
          }}
        >
          <div className="w-full mt-8 border-t border-KMRSx24-Orange">
            <ul className="flex flex-col gap-y-8 py-8 lg:gap-y-16 lg:py-16 border-b border-KMRSx24-Orange">
              <MobileNavLink exact href="/" title="Home" />
              <MobileNavLink href="/leistungen" title="Leistungen" />
              <MobileNavLink href="/projekte" title="Projekte" />
              <MobileNavLink href="/about" title="Über uns" />
              <MobileNavLink href="/news" title="News" />
              <MobileNavLink href="/kontakt" title="Kontakt" />
            </ul>
            <div className="text-KMRSx24-Orange text-sm lg:text-lg flex flex-col mt-8">
              <a href="tel:+49 911 47734580">+49 911 47734580</a>
              <a href="mailto:hello@kommers.io">hello@kommers.io</a>
            </div>
          </div>
        </motion.div>
      </nav>
    </>
  )
}
